import styled from '@emotion/styled'

import {
  ROW_METRICS,
  Stack,
  firstColumn,
  mutedText,
  mutedTitleText,
  rowBorder,
  rowFill,
} from './shared'

const CARD_PADDING = '22px 24px 26px'
const CARD_GAP = '20px'

const Card = styled.div`
  ${rowBorder};
  border-radius: ${ROW_METRICS.radius};
  padding: ${CARD_PADDING};
  background: ${rowFill};
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 12px;
`

const Title = styled.div`
  /* Allow long titles to wrap without pushing the trailing content out of the card. */
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: ${mutedTitleText};
`

const Trailing = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
`

const Fields = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`

// Keep field labels unchanged on muted cards.
const FieldLabel = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: ${p => p.theme.mediumGray};
`

const FieldValue = styled.div`
  margin-top: 4px;
  font-size: 16px;
  color: ${mutedText};
`

const MobileDataTable = ({ columns, rows, className }) => {
  const titleCol = firstColumn(columns)
  const fieldCols = columns.filter(col => col.key !== titleCol.key)

  return (
    <Stack className={className} $gap={CARD_GAP}>
      {rows.map(row => (
        <Card key={row.id} id={row.domId} $muted={row.muted}>
          <Header>
            <Title $muted={row.muted}>{row.cardTitle ?? row.values[titleCol.key]}</Title>
            {row.trailing && <Trailing>{row.trailing}</Trailing>}
          </Header>

          <Fields>
            {fieldCols.map(col => (
              <div key={col.key}>
                <FieldLabel>{col.label}</FieldLabel>
                <FieldValue $muted={row.muted}>{row.values[col.key]}</FieldValue>
              </div>
            ))}
          </Fields>
        </Card>
      ))}
    </Stack>
  )
}

export default MobileDataTable
